import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Container } from "reactstrap";
import HeaderInfoCoin from "./headerInfoCoin";
import DetailInfo from "./detailInfo";
import TreadingView from "./treadingView.jsx";
import { coinsMarkets } from "services/api";
import { useQuery } from "react-query";
import { COINS_PAGES_DELAY } from "constants/useQuery";
import { useSelector } from "react-redux";
import { selectToken } from "store/selector/tokenStore";
import LottieLogo from "components/pages/lottie";
import { logoOptions } from "constants/lotties";

const TreadingBox = (props: any) => {
  const { t } = useTranslation();
  const tokens = useSelector(selectToken);

  const { isLoading, isError, error, data, refetch } = useQuery(
    "coinsMarkets",
    () => coinsMarkets(props.coinName),
    {
      retryDelay: COINS_PAGES_DELAY,
    }
  );
  useEffect(() => {
    if (props.coinName) {
      refetch();
    }
  }, [props.coinName, tokens]);

  let allData, lightweightChartData;

  if (isLoading) {
    return <LottieLogo options={logoOptions} />;
  } else {
    allData = Object.assign({}, ...data);
  }
  // if (isError) {
  //   return <span>{t("Error {{error}}", { error: error })}</span>;
  // }

  return (
    <div>
      <HeaderInfoCoin allData={allData} />
      <Container>
        <Row className="d-flex flex-row-reverse  trading-box-parent">
          <Col xs={{ order: 2 }} md="12" xl="8" lg="8" className="pt-3">
            <TreadingView symbol={allData.symbol} />
          </Col>
          <Col
            xs={{ order: 1 }}
            md="12"
            xl="4"
            lg="4"
            className="mt-n5 mt-md-0"
          >
            <DetailInfo
              allData={allData}
              informationTitle={props.informationTitle}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default TreadingBox;
